export default function AuditTrailBaseController(
  userService
) {
  const vm = this;

  console.log('app.components.advisory.auditTrail.AuditTrailBaseController created');

  /** ********************************
   * Public API
   */

  vm.initPermissions = _initPermissions;

  /** ********************************
   * Private Functions
   */

  function _initPermissions() {
    return userService.getUserPermissionSet('auditTrail').then((permissions) => {
      vm.permissions = permissions;
    });
  }
}
